import { RouteLocation, RouteLocationNormalized } from "vue-router";
import { useUIStore } from "@/store/ui.ts";

export interface ICrumb {
    title: string | undefined;
    route?: RouteLocation;
}

export function setBreadcrumbs({ crumbs, trailingTitle }: { crumbs: RouteLocationNormalized[], trailingTitle?: string }) {
    const parsedCrumbs: ICrumb[] = [
        ...crumbs.map((crumb) => {
            return {
                title: crumb.meta?.breadcrumb as string || crumb.meta?.title as string || crumb.name?.toString(),
                route: crumb,
            };
        }),
        ...trailingTitle ? [{ title: trailingTitle }] : [],
    ];

    const uiStore = useUIStore();
    uiStore.setBreadcrumbs(parsedCrumbs);
}
